import { APIv4 } from 'src/libs/axios';

export type Menu = {
  id: number;
  name: string;
};

export const fetchMenus = (): Promise<Menu[]> =>
  APIv4.get(`/catalogs`).then((response) => response.data);
